import type { SVGProps } from 'react';

export function NoTranscriptionsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={128}
      height={128}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#999"
          d="M28 51c6.62 0 12-5.38 12-12V15c0-6.62-5.38-12-12-12S16 8.38 16 15v24c0 6.62 5.38 12 12 12Zm-4-36c0-2.21 1.79-4 4-4s4 1.79 4 4v24c0 2.21-1.79 4-4 4s-4-1.79-4-4V15Z"
        />
        <path
          fill="#999"
          d="M56 39c0-2.21-1.79-4-4-4s-4 1.79-4 4c0 11.03-8.97 20-20 20S8 50.03 8 39c0-2.21-1.79-4-4-4s-4 1.79-4 4c0 14.08 10.45 25.76 24 27.71V79c0 2.21 1.79 4 4 4s4-1.79 4-4V66.71C45.55 64.76 56 53.08 56 39Z"
        />
        <path
          fill="#616161"
          d="m119.66 36.83-16.48-16.48a7.949 7.949 0 0 0-5.66-2.34H52.01c-1.1 0-2 .9-2 2s.9 2 2 2H91.1v25c0 1.1.9 2 2 2h24.91v54c0 3.31-2.69 6-6 6h-52c-3.31 0-6-2.69-6-6v-30c0-1.1-.9-2-2-2s-2 .9-2 2v30c0 5.51 4.49 10 10 10h52c5.51 0 10-4.49 10-10V42.5c0-2.14-.83-4.14-2.34-5.66l-.01-.01ZM95.09 45V22h2.42c1.07 0 2.07.42 2.83 1.17l16.48 16.48c.76.76 1.17 1.76 1.17 2.83v2.51H95.08l.01.01Z"
        />
        <path
          fill="#616161"
          d="M67 65h29c1.1 0 2-.9 2-2s-.9-2-2-2H67c-1.1 0-2 .9-2 2s.9 2 2 2ZM67 49h11c1.1 0 2-.9 2-2s-.9-2-2-2H67c-1.1 0-2 .9-2 2s.9 2 2 2ZM67 81h37c1.1 0 2-.9 2-2s-.9-2-2-2H67c-1.1 0-2 .9-2 2s.9 2 2 2ZM67 97h17c1.1 0 2-.9 2-2s-.9-2-2-2H67c-1.1 0-2 .9-2 2s.9 2 2 2Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h128v128H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
